/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 공통 스타일요소를 담는 컴포넌트
 * 버전 : 1.0
 * 파일명 : CommonStyled.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-16, 강동형 : 저작권 추가, NextButtonWrapper에 zindex값 추가
 * 수정 : 2025-12-18, 강동형 : 취소 버튼 전용 스타일 추가
 *================================================================
 */

import styled from 'styled-components';

// isValid 값에 따라 초록색 혹은 빨간색으로 바뀌는 문자
export const AlertSpan = styled.span<{ $isValid: boolean }>`
  color: ${({ $isValid }) => ($isValid ? '#39B95B' : '#FF5A5A')};
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
`;

//isBorder값에 따라 선이 보일지를 결정하는 NextButton의 배경
export const NextButtonWrapper = styled.div<{ $isBorder?:boolean }>`
  border-top: ${({$isBorder})=>($isBorder ? '1px solid #EFEFEF':'none')};
  padding : 20px;
  padding-top : 16px;
  background-color : white;
  position: fixed;
  bottom : 0;
  width : 100vw;
  left: 50%;
  transform: translateX(-50%);

  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
`

//disable 값에 따라 disable 되며 배경색이 청록색 혹은 흰색으로 바뀌는 버튼
export const NextButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  background: ${({ disabled }) =>
    disabled
      ? "gray"
      : "#229596"};
  color: white;
  width: 100%;
  height: 46px;
  border: none;
  padding: 10px;
  border-radius: 7px;
  font-size: 16px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  white-space: nowrap;
  box-shadow: 0px 0px 8.3px 0px rgba(0, 0, 0, 0.21);
`;

export const CancleButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ disabled }) =>
    disabled
      ? "gray"
      : "#F5F5F5"};
  color: 7F7F89;
  min-width: 90px;
  height: 46px;
  border: none;
  padding: 10px;
  border-radius: 7px;
  font-size: 16px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  white-space: nowrap;
`;

//disable 값에 따라 disable 되며 전체색이 파란색 혹은 회색으로 바뀌는 버튼
export const ActionButton = styled.button<{ disabled?: boolean }>`
  background: ${({ disabled }) =>
    disabled
      ? "#F5F5F5"
      : "white"};
  color: ${({ disabled }) =>
    disabled
      ? "#7A7A84"
      : "#0AB2E4 "};
  padding: 13px 17px ;
  white-space: nowrap;
  font-size: 16px ;
  font-weight: 500 ;
  height: 46px;
  border: 1px solid ${({ disabled }) =>
    disabled
      ? "#F5F5F5"
      : "#0AB2E4 "};
  border-radius: 5px;
  font-family: 'Pretendard';
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

//인라인 스타일링 버튼
export const CommonButton = styled.button`
  background-color: "gray";
  color: white;
  width: 100%;
  height: 46px;
  border: none;
  padding: 13.5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
`;

//초록색 작은 토글버튼
export const SmallRoundToggleButton = styled.button<{ $isSelected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  padding: 5px 10px; 
  border-radius: 100px;
  border: 1px solid #1E9468;
  background: ${({ $isSelected }) => ($isSelected ? "#1E9468" : "white")};
  width: 77px;
  height: 29px;
  color: ${({ $isSelected }) => ($isSelected ? "white" : "#1E9468")};
  cursor: pointer;
`